import isEqual from 'lodash/isEqual.js'
import pick from 'lodash/pick.js'

import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
} from '../../../../store.js'
import {TAG_FILTER_OR} from '../../../../common/constants/Tags.js'
import {clearTagFilterPanelSearch} from './TagFilterPanel.js'
import {clearFilterPanelSearch} from '../../../OrderListPage/Modals/OrderListFilterModal/FilterPanel.js'
import {
  navigateStocktakeList,
  updateStocktakeTroolean,
  updateSearchText,
  updateStocktakeWarehouseIDs,
  updateStocktakeTags,
  updateStocktakeUntagged,
  updateStocktakeTagFilterBy,
  cleanStocktakeQuery,
  updateStocktakeExcludeTags,
} from '../../stocktakeListFunctions.js'
import deferPromise from '../../../../common/deferPromise.js'
import {ensureTroolean} from '../../../../common/ensure.js'
import {STOCKTAKE_TROOLEAN_FILTERS} from '../../../../common/constants/Stocktakes.js'
import {clearStatusFilterPanelSearch} from './FiltersPanel.js'

const MODAL_FORM = 'stocktake_list_filter_modal'

export const FILTERS_PANEL = 'filters'
export const WAREHOUSE_FILTER_PANEL = 'warehouse'
export const TAG_FILTER = 'tag'
export const MISC_FILTER_PANEL = 'misc'
export const STOCKTAKE_LIST_FILTER_OPTIONS = [
  {value: FILTERS_PANEL, display: 'Status'},
  {value: WAREHOUSE_FILTER_PANEL, display: 'Warehouses'},
  {value: TAG_FILTER, display: 'Tags'},
  {value: MISC_FILTER_PANEL, display: 'Misc'},
]

export async function showStocktakeListFilterModal({query = {}} = {}) {
  const {updates} = await showStocktakeListFilterModalPrime({
    query,
    singleRun: true,
  })

  return await navigateStocktakeList(updates)
}

export async function showStocktakeQueryFilterModal({
  query = {},
  singleRun = true,
} = {}) {
  const {originalForm, updates} = await showStocktakeListFilterModalPrime({
    query,
    singleRun,
  })

  if (!updates) {
    return query
  }

  const stocktakeQuery = cleanStocktakeQuery({...originalForm, ...updates})

  delete stocktakeQuery.sort
  delete stocktakeQuery.limit
  delete stocktakeQuery.offset

  return stocktakeQuery
}

export async function showStocktakeListFilterModalPrime({
  query = {},
  singleRun = true,
  deferredPromise = deferPromise(),
  originalForm,
} = {}) {
  const form = {
    search: query.search || '',
    ...STOCKTAKE_TROOLEAN_FILTERS.reduce((prev, key) => {
      prev[key] = ensureTroolean(query[key])

      return prev
    }, {}),
    warehouse_id: query.warehouse_id || [],
    tag: query.tag || [],
    untagged: query.untagged || false,
    tag_filter_by: query.tag_filter_by || TAG_FILTER_OR,
    exclude_tags: query.exclude_tags || [],
  }

  setForm(MODAL_FORM, {
    singleRun,
    deferredPromise,
    originalForm: originalForm || {...form},
    ...form,
  })

  clearFilterPanelSearch(WAREHOUSE_FILTER_PANEL)
  clearTagFilterPanelSearch()
  clearStatusFilterPanelSearch()

  return deferredPromise.promise
}

export function updateModalForm(...args) {
  updateForm(MODAL_FORM, ...args)
}

export function closeModal(updates) {
  const {originalForm, deferredPromise} = modalFormSelector(getState())

  deferredPromise.resolve({originalForm, updates})

  removeForm(MODAL_FORM)
}

export function clearFilters() {
  const {singleRun, deferredPromise, originalForm} =
    modalFormSelector(getState())

  // re-setup modal form with most of the pieces reused
  // reuse deferredPromise so that any awaits from the original call to show... will resolve
  // reuse originalForm so applyFilter() has the correct thing to compare against
  // reuse singleRun because that is part of the context
  showStocktakeListFilterModalPrime({
    singleRun,
    deferredPromise,
    originalForm,
  })
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export function errorsSelector() {
  const errors = {}

  return errors
}

export async function applyFilter() {
  const {
    originalForm,
    search,
    warehouse_id,
    tag,
    untagged,
    tag_filter_by,
    exclude_tags,
    ...form
  } = modalFormSelector(getState())

  const filters = pick(form, STOCKTAKE_TROOLEAN_FILTERS)
  let updates = {}

  if (search !== originalForm.search) {
    updates = {...updates, ...updateSearchText(search)}
  }

  if (!isEqual(filters, pick(originalForm, STOCKTAKE_TROOLEAN_FILTERS))) {
    updates = {...updates, ...updateStocktakeTroolean(filters)}
  }

  if (!isEqual(warehouse_id, originalForm.warehouse_id)) {
    updates = {...updates, ...updateStocktakeWarehouseIDs(warehouse_id)}
  }

  if (!isEqual(tag, originalForm.tag)) {
    updates = {...updates, ...updateStocktakeTags(tag)}
  }

  if (untagged !== originalForm.untagged) {
    updates = {...updates, ...updateStocktakeUntagged(untagged)}
  }

  if (tag_filter_by !== originalForm.tag_filter_by) {
    updates = {...updates, ...updateStocktakeTagFilterBy(tag_filter_by)}
  }

  if (!isEqual(exclude_tags, originalForm.exclude_tags)) {
    updates = {...updates, ...updateStocktakeExcludeTags(exclude_tags)}
  }

  closeModal(updates)
}
